/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export default function PaymentSuccessUI({
    isArabic,
    isMobile,
    loading,
    isSuccess,
    COLORS,
    handleRedirect,
  }) {
    return (
      <div
        style={{
          background: COLORS.gradient,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "30px",
          fontFamily: "'Tajawal', 'Cairo', sans-serif",
          direction: isArabic ? "rtl" : "ltr",
          color: COLORS.textLight,
        }}
      >
        <div
          style={{
            background: "rgba(255, 255, 255, 0.08)",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: isMobile ? 14 : 18,
            padding: isMobile ? "25px 15px" : "40px 30px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
            textAlign: "center",
            maxWidth: isMobile ? "100%" : 450,
            width: "100%",
            backdropFilter: "blur(12px)",
            margin: isMobile ? "10px" : "0",
          }}
        >
          {loading ? (
            <>
              <h3 style={{ color: COLORS.gold }}>
                {isArabic ? "جارٍ التحقق من حالة الدفع..." : "Checking payment status..."}
              </h3>
              <div style={{ marginTop: "20px" }}>
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: `4px solid rgba(242,180,65,0.3)`,
                    borderTop: `4px solid ${COLORS.gold}`,
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto",
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <h3 style={{ color: COLORS.gold }}>
                {isSuccess
                  ? isArabic
                    ? "تم الدفع بنجاح 🎉"
                    : "Payment Successful 🎉"
                  : isArabic
                  ? "فشل الدفع ❌"
                  : "Payment Failed ❌"}
              </h3>
  
              <p style={{ marginBottom: "25px" }}>
                {isSuccess
                  ? isArabic
                    ? "شكرًا لاشتراكك! تم تأكيد العملية بنجاح."
                    : "Thank you! Your payment was successful."
                  : isArabic
                  ? "حدث خطأ أثناء الدفع، يرجى المحاولة مرة أخرى."
                  : "An error occurred during payment, please try again."}
              </p>
  
              <button
                onClick={handleRedirect}
                style={{
                  background: COLORS.gold,
                  color: COLORS.darkPurple,
                  borderRadius: 10,
                  padding: isMobile ? "10px 20px" : "12px 30px",
                  border: "none",
                  fontWeight: "600",
                  boxShadow: "0 4px 15px rgba(242,180,65,0.4)",
                  cursor: "pointer",
                }}
              >
                {isSuccess
                  ? isArabic
                    ? "الذهاب إلى لوحة التحكم"
                    : "Go to Dashboard"
                  : isArabic
                  ? "العودة إلى الدفع"
                  : "Back to Payment"}
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
  